import Text from '.';

/** @type {UICore.ComponentMeta} */
const TextComponentMeta = {
  id: 'w-text',
  name: '纯文本',
  category: '展示',
  display: 'universal',
  component: Text,
  bindings: [{
    id: '文本内容',
    prop: 'text',
    main: true,
    checkData: s => s.type === 'string' || s.type === 'number' || s.type === 'integer'
  }],
  events: [{
    id: 'click',
    name: '点击文字'
  }, {
    id: 'mouseenter',
    name: '鼠标进入'
  }, {
    id: 'mouseleave',
    name: '鼠标离开'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'text',
      title: '内容',
      type: 'string',
      required: true,
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }, {
      id: 'type',
      title: '类型',
      type: 'string',
      enum: [{
        label: '普通',
        value: ''
      }, {
        label: '标题',
        value: 'heading'
      }, {
        label: '警告',
        value: 'warning'
      }, {
        label: '错误',
        value: 'error'
      }]
    }, {
      id: 'align',
      title: '对齐',
      type: 'string',
      enum: [{
        label: '左对齐',
        value: 'left'
      }, {
        label: '居中对齐',
        value: 'center'
      }, {
        label: '右对齐',
        value: 'right'
      }]
    }]
  },
  presets: [{
    name: '大标题',
    icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-title_1636365651960.png',
    layout: {
      props: {
        type: 'heading',
        text: '请编辑标题内容'
      }
    }
  }, {
    name: '文字',
    icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-markdown_1636364550270.png',
    layout: {
      props: {
        text: '请编辑文本内容'
      }
    }
  }],
  getLayoutName(layout) {
    var _layout$props;
    if (((_layout$props = layout.props) === null || _layout$props === void 0 ? void 0 : _layout$props.type) === 'heading') return '标题';
    return '文字';
  },
  fitData({
    dataSchema,
    dataPath
  }) {
    if (dataSchema.type === 'string') {
      return [{
        type: 'display',
        name: '纯文本',
        layout: {
          type: 'w-text',
          bindings: {
            文本内容: dataPath
          },
          props: {
            text: `{{ data.${dataPath} }}`
          }
        }
      }];
    }
  },
  designerQuickEdit: [{
    trigger: {
      dblclick: true,
      selected: {
        onlyInserting: true
      }
    },
    content: ['prop:text']
  }]
};
export default TextComponentMeta;